import React, { useState, useEffect, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";

const CustomColorCheckbox = withStyles({
  root: {
    color: "#23AFC4",
    "&$checked": {
      color: "#23AFC4",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);
export default function RenderCheckBox(props) {
  const { members, item, setUserValue, setCheckedSelected } = props;
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const found = members.find((m) => m === item.user_id);

    if (found) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [members, item]);

  const handleChange = (e) => {
    setChecked(e.target.checked);

    if (e.target.checked) {
        setUserValue([...members, item.user_id]);
        setCheckedSelected([item.user_id])
    } else {
        setUserValue((prev) =>
          prev.filter((itm) => itm !== item.user_id)
        );
        setCheckedSelected([item.user_id])
    }
  };
  return (
    <Fragment>
      {checked && (
        <CustomColorCheckbox
          checked
          style={{
            transform: "scale(0.7)",
          }}
          onChange={handleChange}
        />
      )}

      {!checked && (
        <CustomColorCheckbox
          style={{
            transform: "scale(0.7)",
          }}
          onChange={handleChange}
        />
      )}
    </Fragment>
  );
}
